import balanceAdjustments from '@/locales/en/accounting/balanceAdjustments.locales';
import payments from '@/locales/en/accounting/payments.locales';

export default {
    ...balanceAdjustments,
    ...payments,
};
